var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 63,
    viewBox: "0 0 40 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38086 0.23999H0.880859V5.23999H2.38086V0.23999ZM0.880859 12.24H2.38086V17.24H0.880859V12.24ZM0.880859 24.24H2.38086V29.24H0.880859V24.24ZM0.880859 48.24H2.38086V53.24H0.880859V48.24ZM2.38086 60.24H0.880859V62.7H2.38086V60.24ZM0.880859 36.24H2.38086V41.24H0.880859V36.24ZM39.7109 12.24H38.2109V17.24H39.7109V12.24ZM38.2109 24.24H39.7109V29.24H38.2109V24.24ZM39.7109 0.23999H38.2109V5.23999H39.7109V0.23999ZM38.2109 48.24H39.7109V53.24H38.2109V48.24ZM39.7109 36.24H38.2109V41.24H39.7109V36.24ZM38.2109 60.24H39.7109V62.7H38.2109V60.24ZM5.90039 30.73H3.40039V32.23H5.90039V30.73ZM23.1113 30.73H28.1713V32.23H23.1113V30.73ZM17.0307 30.73H11.9707V32.23H17.0307V30.73ZM34.251 30.73H36.751V32.23H34.251V30.73Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperH);
export default __webpack_public_path__ + "static/media/UPPER_H.eb42951a1204e4da01ba89c137cb26e5.svg";
export { ForwardRef as ReactComponent };